module.exports = __webpack_public_path__ + "img/main-oso.f756cf93.jpg";